import { render, staticRenderFns } from "./LegacyEmail.vue?vue&type=template&id=889e1812"
import script from "./LegacyEmail.vue?vue&type=script&lang=js"
export * from "./LegacyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports